module.exports = __webpack_public_path__ + "static/media/update.dcb5313f.svg";